var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectRepository(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_689_5911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.125 11.1875H7.875V12.3125H10.125V11.1875Z",
    fill: "#DCE0E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.375 1.625V16.25C3.375 16.5484 3.49353 16.8345 3.7045 17.0455C3.91548 17.2565 4.20163 17.375 4.5 17.375H13.5C13.7984 17.375 14.0845 17.2565 14.2955 17.0455C14.5065 16.8345 14.625 16.5484 14.625 16.25V1.625H3.375ZM13.5 16.25H4.5V9.5H13.5V16.25ZM13.5 8.375H4.5V6.125H13.5V8.375ZM4.5 5V2.75H13.5V5H4.5Z",
    fill: "#DCE0E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_689_5911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectRepository);
export default __webpack_public_path__ + "static/media/project_repository.51b1c9ec9ef845fe4d13bc96f5b5a48d.svg";
export { ForwardRef as ReactComponent };